import { css, createGlobalStyle } from 'styled-components';
import { objectEntries } from '../../../utils/objectEntries.js';

/**
 * Create all CSS variables for the theme, based on the theme object's keys & values
 * prefix with "t-" to avoid conflicts with other third-party CSS variables
 * @example
 * createCSSVariables({ fontSize: { small: '1rem', large: '2rem' } }
 * // Resulting CSS:
 * --t-fontSize-small: 1rem;
 * --t-fontSize-large: 2rem;
 */
var createCSSVariables = function createCSSVariables(tokens, prefix) {
  if (prefix === void 0) {
    prefix = '--t';
  }
  return objectEntries(tokens).flatMap(function (_ref) {
    var key = _ref[0],
      value = _ref[1];
    if (typeof value === 'object' && value !== null) {
      return createCSSVariables(value, prefix + "-" + key);
    }
    return prefix + "-" + key + ": " + value + ";";
  }).join('');
};
var styles = css([":root{", ";}"], function (props) {
  return createCSSVariables(props.theme);
});
var ThemeVariables = createGlobalStyle(["", ""], styles);

export { ThemeVariables };
